"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logMethod = exports.logWarn = exports.logTrace = exports.logError = exports.logDebug = exports.initialize = void 0;
var log = require("loglevel");
var utilities_1 = require("./utilities");
function initialize(logLevel) {
    if (typeof logLevel === 'number') {
        log.setDefaultLevel(logLevel);
    }
    else {
        log.setDefaultLevel(log.levels.SILENT);
    }
}
exports.initialize = initialize;
function logDebug(message) {
    log.debug(message);
}
exports.logDebug = logDebug;
function logError(message) {
    log.error(message);
}
exports.logError = logError;
function logTrace(message) {
    log.trace(message);
}
exports.logTrace = logTrace;
function logWarn(message) {
    log.warn(message);
}
exports.logWarn = logWarn;
function logMethod(delegate) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var result;
    if (utilities_1.isFunction(delegate)) {
        try {
            result = delegate.apply(null, args);
        }
        catch (error) {
            logError(error.message);
        }
    }
    else {
        logError('Method call is not a function!');
    }
    return result;
}
exports.logMethod = logMethod;
